import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Attendance from "@/pages/Attendance";
import Warehouse from "@/pages/Warehouse";
import Branch from "@/pages/Branch";
import Resi from "@/pages/Resi";
import Inventory from "@/pages/Inventory";
import PurchaseRequests from "@/pages/PurchaseRequests";
import AdminUsers from "@/pages/AdminUsers";
import AdminBranches from "@/pages/AdminBranches";
import AdminProducts from "@/pages/AdminProducts";
import Activities from "@/pages/Activities";
import Balance from "@/pages/Balance";
import SettingsPage from "@/pages/Settings";
import Omset from "@/pages/Omset";
import Kinerja from "@/pages/Kinerja";
import Pengeluaran from "@/pages/Pengeluaran";
import Share from "@/pages/Share";
import AttendanceVerify from "@/pages/AttendanceVerify";
import Storefront from "@/pages/Storefront";
import StoreAdmin from "@/pages/StoreAdmin";
import AffiliateHome from "@/pages/AffiliateHome";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-start p-8 text-slate-500">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function HomeRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-start p-8 text-slate-500">Memuat...</div>;
  if (!user) return <Storefront />;
  if (user.role === "affiliate") return <Navigate to="/affiliate" replace />;
  return <Protected><Dashboard /></Protected>;
}

function App() {
  return (
    <div className="App">
      <Toaster richColors position="top-center" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/toko" element={<Storefront />} />
            <Route path="/affiliate" element={<AffiliateHome />} />
            <Route path="/toko-admin" element={<Protected roles={["admin","keuangan","gudang","cabang"]}><StoreAdmin /></Protected>} />
            <Route path="/" element={<HomeRoute />} />
            <Route path="/absensi" element={<Protected><Attendance /></Protected>} />
            <Route path="/gudang" element={<Protected roles={["admin","gudang"]}><Warehouse /></Protected>} />
            <Route path="/cabang-kota" element={<Protected roles={["admin","cabang"]}><Branch /></Protected>} />
            <Route path="/resi" element={<Protected roles={["admin","cabang","keuangan"]}><Resi /></Protected>} />
            <Route path="/inventaris" element={<Protected><Inventory /></Protected>} />
            <Route path="/permintaan" element={<Protected><PurchaseRequests /></Protected>} />
            <Route path="/pengguna" element={<Protected roles={["admin"]}><AdminUsers /></Protected>} />
            <Route path="/cabang" element={<Protected roles={["admin"]}><AdminBranches /></Protected>} />
            <Route path="/produk" element={<Protected roles={["admin","gudang"]}><AdminProducts /></Protected>} />
            <Route path="/aktivitas" element={<Protected roles={["admin"]}><Activities /></Protected>} />
            <Route path="/laporan" element={<Protected roles={["admin","keuangan"]}><Balance /></Protected>} />
            <Route path="/omset" element={<Protected roles={["admin","keuangan"]}><Omset /></Protected>} />
            <Route path="/kinerja" element={<Protected roles={["admin","keuangan"]}><Kinerja /></Protected>} />
            <Route path="/pengeluaran" element={<Protected roles={["admin","keuangan"]}><Pengeluaran /></Protected>} />
            <Route path="/pengaturan" element={<Protected roles={["admin"]}><SettingsPage /></Protected>} />
            <Route path="/bagikan" element={<Protected roles={["admin"]}><Share /></Protected>} />
            <Route path="/verifikasi-absen" element={<Protected roles={["admin"]}><AttendanceVerify /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
